module.exports = __webpack_public_path__ + "static/img/logo.d8dc5eca.png";